export const listGroupsQueryKey = 'listGroups' as const
